export const createPaymentSlice = (set) => ({
  payment_session_id: null,
  cashfree_order_id: null,
  payment_loading: false,
  payment_error: null,
  payment_status: null, // null | 'pending' | 'success' | 'failed'

  setPaymentSession: (session_id, cf_order_id) =>
    set({ payment_session_id: session_id, cashfree_order_id: cf_order_id }),

  setPaymentStatus: (status) => set({ payment_status: status }),

  resetPayment: () =>
    set({
      payment_session_id: null,
      cashfree_order_id: null,
      payment_loading: false,
      payment_error: null,
      payment_status: null,
    }),
});
